import type { POI, Sentiero, Itinerario } from '../domain/types';
import { StaticDataSource } from './static-source';
import { ApiDataSource } from './api-source';

export interface DataSource {
  getPOIs(): Promise<POI[]>;
  getPOIById(id: string): Promise<POI | null>;
  getSentieri(): Promise<Sentiero[]>;
  getItinerari(): Promise<Itinerario[]>;
}

export function resolveDataSource(): DataSource {
  const mode = import.meta.env.VITE_DATA_SOURCE ?? 'static';
  if (mode === 'api') {
    const base = import.meta.env.VITE_API_BASE_URL;
    if (!base) {
      throw new Error('VITE_API_BASE_URL required when VITE_DATA_SOURCE=api');
    }
    return new ApiDataSource(base);
  }
  return new StaticDataSource();
}
